import { render, staticRenderFns } from "./AttributeDefinitionTable.global.vue?vue&type=template&id=3719a898&lang=pug&"
import script from "./AttributeDefinitionTable.global.vue?vue&type=script&lang=ts&"
export * from "./AttributeDefinitionTable.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports